import Image from './NextImage'
import styled from '@emotion/styled'

import FullStarIcon from '../../public/assets/icons/full-star.svg'

const Flex = styled.div`
  display: flex;
`
const ImgContainer = styled.div`
  margin-right: 4px;
`

interface Props {
  size?: number
}

const FiveStars: React.FC<Props> = ({ size = 16 }) => {
  return (
    <Flex>
      <ImgContainer><Image src={FullStarIcon} alt='full-star' width={`${size}px`} height={`${size}px`} /></ImgContainer>
      <ImgContainer><Image src={FullStarIcon} alt='full-star' width={`${size}px`} height={`${size}px`} /></ImgContainer>
      <ImgContainer><Image src={FullStarIcon} alt='full-star' width={`${size}px`} height={`${size}px`} /></ImgContainer>
      <ImgContainer><Image src={FullStarIcon} alt='full-star' width={`${size}px`} height={`${size}px`} /></ImgContainer>
      <ImgContainer><Image src={FullStarIcon} alt='full-star' width={`${size}px`} height={`${size}px`} /></ImgContainer>
    </Flex>
  )
}

export default FiveStars
